import React,  { useState, useEffect } from 'react';

const CircleWithLineAndTriangle = ({data, islink}) => {

  const [dmCircle, setDmCircle] = useState({ //все входящие данные-числовые
    angleCurrent: 0,
    param4: 0,
    offsetNulN: 0,
    flagBarrier: 0,
    angleForward: 65535,
    angleRevers: 65535,
  })

  //проверка входных данных
  useEffect(() => {
    setDmCircle({
      angleCurrent: data?.AngleCurrent || 0,
      param4: data?.param4 || 0,
      offsetNulN: data?.OffsetNulN || 0,
      flagBarrier: data?.FlagBarrier || 0,
      angleForward: data?.AngleForward || 65535,
      angleRevers: data?.AngleRevers || 65535,
    })
  },[data])

  const checkBit = (num, bitPosition) => {
    return (num & (1 << bitPosition)) !== 0;
  };
  // Параметры окружности 
  const radius = 38;
  const centerX = 40;
  const centerY = 40;
  let angletriangle=0;

    //данные по положениию
  const angleCurrent=dmCircle?.angleCurrent;
  const forward=checkBit(dmCircle?.param4, 6);
  const revers=checkBit(dmCircle?.param4, 4);
  const nowater=checkBit(dmCircle?.param4, 3);
  const offsetNulN=dmCircle?.offsetNulN;
  //данные по барьерам
  const flagBarrier = dmCircle?.flagBarrier;
  const angleForward = dmCircle?.angleForward;
  const angleRevers = dmCircle?.angleRevers;
   
  // Определяем цвета в зависимости от состояния машины
  const colorCircle = islink==='Online' ? (nowater ? ("#ebfbee"):("#2196f333")) : ("#dedcdc");   
  const colorOutline = islink==='Online' ? (nowater ? ("#92f7a5"):("#1492fac7")) : ("#b8b4b4"); 

  //Основная линия - текущее положение
  const lineLength = radius; // Длина линии равна радиусу окружности
  const angle = Math.PI * (angleCurrent*1-90+offsetNulN*1)/ 180; // Угол в радианах (45 градусов)
  // Конечная точка линии 1
  const endX = centerX + lineLength * Math.cos(angle);
  const endY = centerY + lineLength * Math.sin(angle);

    // Параметры линии 2 - нулевое положение
    const angle2 = Math.PI * (offsetNulN-90)/ 180; // Угол в радианах (45 градусов)
    // Конечная точка линии2
    const endX2 = centerX + lineLength * Math.cos(angle2);
    const endY2 = centerY + lineLength * Math.sin(angle2);

    //длинна линии барьера
    const lineLengthBarrier = radius+7; // Длина линии больше радиуса окружности

    //параметры линии барьера при движении вперед
    const angleF = Math.PI * (angleForward*1-90+offsetNulN*1)/ 180; // Угол в радианах
    //конечная точка линии - Барьер Вперед
    const endXF = centerX + lineLengthBarrier * Math.cos(angleF);
    const endYF = centerY + lineLengthBarrier * Math.sin(angleF);

    //параметры линии барьера при движении назад
    const angleR = Math.PI * (angleRevers*1-90+offsetNulN*1)/ 180; // Угол в радианах
     //конечная точка линии - Барьер Назад
     const endXR = centerX + lineLengthBarrier * Math.cos(angleR);
     const endYR = centerY + lineLengthBarrier * Math.sin(angleR);
  
  // Параметры треугольника 
  const triangleBase = 15; // Длина основания треугольника

  // Вершины треугольника
    const x1=endX, y1=endY;
    const x2=centerX + (lineLength-triangleBase) * Math.cos(angle),
    y2=centerY + (lineLength-triangleBase) * Math.sin(angle);
   if(revers){
      angletriangle=Math.atan2(y2 - y1, x2 - x1); // Угол меняем 1 и 2 местами чтобы сменить направление
    }
    if(forward){
      angletriangle= Math.atan2(y1 - y2, x1 - x2); // Угол меняем 1 и 2 местами чтобы сменить направление
    }
    const x3=(x1 + x2) / 2 + (triangleBase / 2) * Math.cos(angletriangle+ Math.PI / 2),
    y3=(y1 + y2) / 2 + (triangleBase / 2) * Math.sin(angletriangle + Math.PI / 2);

  const trianglePoints = [
    x1, y1, // угол примыкающий к окружности 
    x2,y2, // угол между центром круга и окружностью
    x3,y3 // Верхняя точка
  ].join(',');

  // Функция для создания дуги с учетом направления
  const describeArc = (x, y, radius, startAngleDeg, endAngleDeg) => {
    // Конвертируем градусы в радианы и корректируем на offsetNulN
    const startAngle = Math.PI * (startAngleDeg * 1 - 90 + offsetNulN * 1) / 180;
    const endAngle = Math.PI * (endAngleDeg * 1 - 90 + offsetNulN * 1) / 180;
    
    // Определяем направление дуги (по часовой стрелке)
    const sweepFlag = 1;
    
    // Вычисляем разницу углов
    let angleDiff = endAngle - startAngle;
    if (angleDiff < 0) angleDiff += 2 * Math.PI;
    
    // Определяем, нужно ли рисовать большую дугу
    const largeArcFlag = angleDiff > Math.PI ? 1 : 0;

    const start = {
      x: x + radius * Math.cos(startAngle),
      y: y + radius * Math.sin(startAngle)
    };
    const end = {
      x: x + radius * Math.cos(endAngle),
      y: y + radius * Math.sin(endAngle)
    };

    return [
      "M", start.x, start.y,
      "A", radius, radius, 0, largeArcFlag, sweepFlag, end.x, end.y
    ].join(" ");
  };


  return (
    <svg width={80} height={80}>
      {/* Окружность */}
      <circle
        cx={centerX}
        cy={centerY}
        r={radius}
        stroke={colorOutline}
        strokeWidth={2}
        fill={colorCircle}
      />

       {/* Дуга разрешенной зоны */}
       {flagBarrier === 1 && angleForward !== 65535 && angleRevers !== 65535 &&(
        <path
          d={describeArc(centerX, centerY, radius/2, angleRevers, angleForward)}
          fill="none"
          stroke="gray"
          strokeWidth="2"
        />
      )}

      {/* Линия от центра до края окружности нулевое положение*/}
      <line
        x1={centerX}
        y1={centerY}
        x2={endX2}
        y2={endY2}
        stroke="yellow"
        strokeWidth={3}
      />

      {/* Линия от центра до края окружности основная линия - траектория*/}
      <line
        x1={centerX}
        y1={centerY}
        x2={endX}
        y2={endY}
        stroke="black"
        strokeWidth={2}
      />

      {/* Линия от центра за край окружности - барьер при движении вперед*/}
      {flagBarrier === 1 && angleForward !== 65535 &&(
      <line
        x1={centerX}
        y1={centerY}
        x2={endXF}
        y2={endYF}
        stroke="gray"
        strokeWidth={2}
      />
      )}

       {/* Линия от центра за край окружности - барьер при движении назад*/}
       {flagBarrier === 1 && angleRevers !== 65535 &&(
       <line
        x1={centerX}
        y1={centerY}
        x2={endXR}
        y2={endYR}
        stroke="gray"
        strokeWidth={2}
      />
      )}

      {/* Центр окружности - точка */}
      <circle
        cx={centerX}
        cy={centerY}
        r={2}
        stroke={"#000000"}
        strokeWidth={1}
        fill={"#000000"}
      />

      {/* Треугольник на конце линии */}
      {islink==='Online' && revers !== forward && (<polygon
        points={trianglePoints}
        fill="green"
        stroke="black"
        strokeWidth={1}
      />)
      }     
    </svg>
  );
};

export default CircleWithLineAndTriangle;